import {
  Checkbox,
  CheckboxProps,
  Radio,
  RadioProps,
  FormControl,
  FormControlProps,
} from '@mui/material';
import { OutlinedTextFieldProps } from '@mui/material/TextField/TextField';

export function QSCheckbox({ ...props }: CheckboxProps) {
  return <Checkbox {...props} />;
}

export function QSRadio({ ...props }: RadioProps) {
  return <Radio {...props} />;
}

export function QSFormControl({ ...props }: FormControlProps) {
  return <FormControl {...props} />;
}

export interface NumericFieldI extends OutlinedTextFieldProps {
  onChangeValue: (a: string | null) => void;
}
